import React from 'react';
import {IListConfigRelationColumn} from '@src/@interfaces/components/List/IListConfigRelationColumn';
import SelectColumn from './SelectColumn';
import {IEmptyModel} from '@src/@interfaces/IEmptyModel';
import OrderStatusRepresentation from '@src/components/StatusRepresentations/OrderStatusRepresentation';

export class RelationColumn<
        Model extends IEmptyModel = IEmptyModel
> extends SelectColumn<Model, IListConfigRelationColumn> {
    render() {
        return this.tryToRenderBadge() ?? super.render();
    }

    protected tryToRenderBadge() {
        const relation = this.getSelectStatementValueContainer();
        if (!relation || typeof relation !== 'object') {
            return null;
        }

        const array = Array.isArray(relation) ? relation : [relation];

        const items = array.reduce<React.ReactNode[]>((res, relation, index) => {
            const [bgColor, textColor] = [relation.bg_color, relation.text_color];
            if (!bgColor && !textColor) {
                return res;
            }

            let value;
            if (this.config.valueFrom) {
                value = relation.hasOwnProperty(this.config.valueFrom) ? relation[this.config.valueFrom] : null;
            } else if (!value && this.config.select) {
                value = this.resolveSelectStatement(index);
            }

            if (!value) {
                return res;
            }

            res.push(
                    <OrderStatusRepresentation
                            key={`${this.model?.name}--${relation.id ?? index}`}
                            label={value}
                            textColor={textColor}
                            bgColor={bgColor}
                    />
            );

            return res;
        }, []);

        return items.length ? <>{items}</> : null;
    }

    protected get value() {
        const relation = this.getSelectStatementValueContainer();
        if (!relation || typeof relation !== 'object') {
            return null;
        }

        const toString = (field: string) => (Array.isArray(relation) ? relation : [relation]).map(relation => {
            return relation.hasOwnProperty(field) ? relation[field] : null;
        }).join('; ');

        if (this.config.valueFrom) {
            return toString(this.config.valueFrom);
        }

        if (this.config.select) {
            return this.resolveSelectStatement()?.join(';');
        }

        return toString('id');
    }

    protected getSelectStatementValueContainer() {
        const model = this.model;
        const relationName = this.config.relation as keyof Model;

        return relationName in model ? (
                Array.isArray(model[relationName]) ?
                        model[relationName] as Model[] :
                        model[relationName] as Model
        ) : null;
    }
}

export default React.memo(RelationColumn);
